import React, { useContext } from 'react'
import { renderTextInput } from 'components/forms/SharedInputs'
import { Field, ErrorMessage } from 'formik'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import Logo from 'images/logo.svg'

const SignIn = ({ errors, touched, loginError, closeModal }) => {
  const modal_context = useContext(modalContext)
  const { showForgotPasswordModal } = modal_context || {}

  return (
    <div className="signin__form new-form-fields">
      <div className="signin__form__logo">
        <img src={Logo} alt="Dailybreak" className="logo" />
      </div>
      <ul className="form__elements">
        <li className="form__element">
          <Field
            name="email_signin"
            type="text"
            label="Email"
            placeholder={'Email'}
            component={renderTextInput}
            error={errors.email_signin}
            touched={touched.email && true}
          />

          <ErrorMessage name="email" />
        </li>

        <li className="form__element">
          <Field
            name="password_signin"
            type="password"
            label="Password"
            placeholder={'Password'}
            component={renderTextInput}
            error={errors.password_signin}
            touched={touched.password && true}
          />
          <ErrorMessage name="password" />
        </li>
        <div className="form__submit-wrapper">
          <input className="btn" type="submit" value="Sign In" />
        </div>
        {modal_context && (
          <a
            href="#"
            className="forgot"
            onClick={() => showForgotPasswordModal()}
          >
            Forgot your password?
          </a>
        )}
        {loginError && <p className="error">{loginError}</p>}
      </ul>
    </div>
  )
}

export default SignIn
